import styled from "styled-components";
import {
  scaleOnClickAnim,
  whiteBgOnClickAnim,
  OPboxInAnim,
  OPboxOutAnim,
  OPfadeInAnim,
  OPfadeOutAnim,
} from "../../animations";

export const HistoryContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  font-size: 20px;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #db4646;
  animation: ${(p) => (p.aboveAnim ? OPfadeInAnim : OPfadeOutAnim)};
  animation-duration: 0.167s;
  animation-fill-mode: forwards;
`;

export const HistoryBox = styled.div`
  padding: 60px 30px;
  width: 375px;
  overflow-y: scroll;
  scrollbar-width: none;
  margin: auto;
  position: relative;
  height: 667px;
  animation: ${(p) => (p.aboveAnim ? OPboxInAnim : OPboxOutAnim)};
  animation-duration: 0.333s;
`;

export const Title = styled.div`
  font-size: 26px;
  text-align: center;
  color: #483b3b;
  text-transform: uppercase;
`;

export const CardsContainer = styled.div`
  padding: 56px 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  position: relative;
  will-change: transform;
`;

export const Results = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  p {
    text-transform: uppercase;
    font-size: 10px;
    text-align: center;
    color: #483b3b;
    width: 83px;
  }
`;

export const CardBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  p {
    margin: 14px 0 48px;
    font-size: 12px;
  }
`;

export const Card = styled.div`
  width: 82px;
  position: relative;
  background: #e7e2de;
  box-shadow: 0 4px 7px 0 rgba(0, 0, 0, 0.4);
  border-radius: 13px;
  padding: 18px 0;
  align-items: center;
  ${(p) => (p.col ? "opacity: 0.5" : "opacity: 1")}
`;

export const CardSymbol = styled.div`
  font-size: 40px;
  text-align: center;
  ${(p) => (!p.col ? "color: #db4646;" : "color: #483b3b;")}
`;

export const CardSuit = styled.div`
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  svg {
    width: 100%;
    height: 100%;
  }
`;

export const Subtext = styled.span`
  margin: 3px;
  transform: translateY(-30px);
  p {
    color: #483b3b;
    font-size: 20px;
    width: 14px;
    margin: 0;
  }
`;

export const MainBtn = styled.div`
  bottom: 60px;
  background: #ffb000;
  border: solid 3px #ffb000;
  border-radius: 38px;
  color: #db4646;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 2;
  animation: ${(p) => (p.set ? scaleOnClickAnim : null)};
  animation-duration: 0.333s;
  animation-fill-mode: forwards;
  position: fixed;
  width: 100%;
  max-width: 315px;
  bottom: 30px;
  height: 56px;
  font-size: 20px;
  left: 30px;
  pointer-events: ${(p) => (p.soundPlayed ? "none" : "auto")};
  :after {
    content: "";
    position: absolute;
    height: 100%;
    width: 100%;
    background: #ffffff;
    border: solid 3px #ffffff;
    border-radius: 38px;
    opacity: 0;
    right: 50%;
    bottom: 50%;
    transform: translate(50%, 50%);
    animation: ${(p) => (p.set ? whiteBgOnClickAnim : null)};
    animation-duration: 0.5s;
    animation-fill-mode: forwards;
  }
`;
